import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-host',
  imports: [CommonModule],
  template: `
    <div class="fixed top-[100px] right-4 z-[200] flex flex-col gap-2 items-end pointer-events-none">
      @for (t of toast.toasts(); track t.id) {
        <div class="pointer-events-auto text-white text-[14px] font-medium px-5 py-3 rounded-sm shadow-lg max-w-[340px]"
             [style.background]="t.type === 'error' ? '#c0392b' : '#f04e4e'"
             style="animation: toastIn .2s ease-out">
          {{ t.message }}
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes toastIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
  `],
})
export class ToastHost {
  readonly toast = inject(ToastService);
}
